<template>
  <div>
    <div v-if="readOnly" class="w-full">
      <FieldTitle :model="model" />
    </div>

    <!--Read only-->
    <div v-if="readOnly" class="cursor-default w-full">

      <!-- 1. Dropdown with single select-->
      <DropdownSingleSelect :readOnly="true" :model="model" :noBorderLayout="noBorderLayout" />

      <!-- 2. Dropdown with multiselect-->
      <DropdownMultiSelect :readOnly="true" :model="model" :noBorderLayout="noBorderLayout" />

      <!-- 3. Checkboxes-->
      <CheckBoxes :readOnly="true" :model="model" :noBorderLayout="noBorderLayout" />

    </div>

    <!-- Edit mode -->
    <div v-else class="flex">
      <div class="w-full">
        <div class="w-full">
          <FieldTitle :model="model" />
        </div>
        <div>
          <font-awesome-icon v-show="isSaving" icon="spinner" class="animate-spin absolute right-2.5 top-3" />
        </div>

        <!-- 1. Dropdown with single select-->
        <DropdownSingleSelect :readOnly="false" :model="model" :pageId="pageId" />

        <!-- 2. Dropdown with multiselect-->
        <DropdownMultiSelect :readOnly="false" :model="model" :pageId="pageId" />

        <!-- 3. Checkboxes-->
        <CheckBoxes :readOnly="false" :model="model" :pageId="pageId" />

      </div>

      <!--Comments-->
      <div class="hidden pr-0 mb-4 xl:block lg:pl-4">
        <CommentPane v-if="!model.deactivateComments" :model="model.comments" :contentGuid="model.contentGuid"
          :pageId="pageId" :fieldTitle="model.title" @pinned-change="onCommentPanePinnedChange" />
      </div>
    </div>
  </div>
</template>

<script>
import CommentPane from '@/views/components/schema/CommentPane.vue';
import FieldTitle from '@/views/components/schema/common/FieldTitle.vue';
import DropdownSingleSelect from '@/views/components/schema/relationSelector/DropdownSingleSelect.vue';
import DropdownMultiSelect from '@/views/components/schema/relationSelector/DropdownMultiSelect.vue';
import CheckBoxes from '@/views/components/schema/relationSelector/CheckBoxes.vue';

export default {
  props: {
    model: {
      type: Object,
      required: true,
    },
    pageId: {
      type: String,
      required: false,
    },
    readOnly: {
      type: Boolean,
      required: false,
    },
    preview: {
      type: Boolean,
      required: false,
    },
    noBorderLayout: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    DropdownSingleSelect,
    DropdownMultiSelect,
    CheckBoxes,
    CommentPane,
    FieldTitle,
  },
  data() {
    return {
      type: this.model.properties.selectType,
      isSaving: false,
    };
  },
  methods: {
    onCommentPanePinnedChange(payload) {
      this.$emit('comment-pane-pinned-change', payload);
    },
  },
  emits: ['comment-pane-pinned-change'],
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>
